var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5C12.9162 10.5 14.875 8.54125 14.875 6.125C14.875 3.70875 12.9162 1.75 10.5 1.75C8.08375 1.75 6.125 3.70875 6.125 6.125C6.125 8.54125 8.08375 10.5 10.5 10.5Z",
    stroke: "#5D6577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.013 19.25C18.013 15.8638 14.6442 13.125 10.4967 13.125C6.34922 13.125 2.98047 15.8638 2.98047 19.25",
    stroke: "#5D6577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.8929H19.5625L24.1708 7.62624L22.6083 5.84052L18 11.1072V12.8929ZM18.8333 11.5024L22.6083 7.18814L22.9917 7.62624L19.2167 11.9405H18.8333V11.5024ZM24.4042 4.45957C24.3656 4.41543 24.3198 4.3804 24.2694 4.35651C24.219 4.33261 24.165 4.32031 24.1104 4.32031C24.0558 4.32031 24.0018 4.33261 23.9514 4.35651C23.901 4.3804 23.8552 4.41543 23.8167 4.45957L23.0542 5.331L24.6167 7.11671L25.3792 6.24529C25.4178 6.20123 25.4484 6.1489 25.4693 6.0913C25.4903 6.03369 25.501 5.97194 25.501 5.90957C25.501 5.84721 25.4903 5.78545 25.4693 5.72785C25.4484 5.67024 25.4178 5.61791 25.3792 5.57386L24.4042 4.45957Z",
    fill: "#5D6577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.6e950850444c59580a75668c94b526f9.svg";
export { ForwardRef as ReactComponent };